<template>
  <div class="RouterMenuBox">
    <transition name="rm-expand">
      <div v-if="effectiveShowSider" key="expanded">
        <!-- Module Tab Switcher -->
        <div class="module-tab-wrap" data-guide-key="Module Switch" :class="{'module-tab-wrap--shadow': tabScrolled}" v-if="availableModuleCount > 1">
          <div class="module-tab">
            <div v-if="hasHotel" class="module-tab__item" :class="{active: activeModule === 'hotel'}" @click="switchModule('hotel')">
              <SvgIcon iconClass="dashboard" />
              <span>{{menu['Hotel'] || 'Hotel'}}</span>
            </div>
            <div v-if="hasRestaurant" class="module-tab__item" :class="{active: activeModule === 'restaurant'}" @click="switchModule('restaurant')">
              <SvgIcon iconClass="Restaurant" />
              <span>{{menu['F&B'] || 'F&B'}}</span>
            </div>
            <!-- Brand styling is TBD-provisional — reusing the Hotel tab's own
                 icon/look until design finalizes a dedicated one. -->
            <div v-if="hasBrand" class="module-tab__item" :class="{active: activeModule === 'brand'}" @click="switchModule('brand')">
              <SvgIcon iconClass="dashboard" />
              <span>{{menu['Brand'] || 'Brand'}}</span>
            </div>
          </div>
        </div>
        <transition-group name="rm-section-fade" tag="div">
          <div
            class="showPathBoxList"
            :class="{'intelligence-section': item.intelligence}"
            v-for="item in activeShowPathData"
            :key="item.title || (item.data && item.data[0] && item.data[0].text)"
            :data-guide-key="item.title || (item.data && item.data[0] && item.data[0].text)"
          >
            <p class="title" v-if="item.title">{{menu[item.title]}}</p>
            <div
              class="showPathListContent"
              v-for="(list, listIndex) in item.data"
              :key="list.loading ? ('skeleton-' + listIndex) : (list.brandKey || '') + (list.isBrandDetailsLink ? '-details' : '') + (list.text || list.title || listIndex)"
            >
              <!-- Placeholder row for a "Brand Overview" section whose data
                   hasn't arrived yet (see isBrandOverviewLoading) — same row
                   height/padding as a real row so nothing shifts once the
                   real rows replace these. -->
              <div v-if="list.loading" class="showText showText--skeleton">
                <span class="skeleton-bar" :style="{width: list.width}"></span>
              </div>
              <template v-else>
                <div class="showText" :class="{active:isMenuRowActive(list), 'intelligence-item':list.icon==='ai-chat', 'showText--sub':list.isBrandDetailsLink}" @click="goPath(list)">
                  <AiChatIcon v-if="list.icon==='ai-chat'" />
                  <!-- 品牌模式的菜单项不带图标（icon 为空），这里必须判空，
                       否则会渲染出一个 20px 的空 svg 占位、文字对不齐 -->
                  <SvgIcon v-else-if="list.icon" :iconClass="list.icon"/>
                  <div class="Content_text" :class="{Content_text1:list.children}">
                    <ElThTooltip :placement="'right'" :data="list.textLiteral || menu[list.text]"/>
                    <i :class="{expandAct:!list.expand}" v-if="list.children" class="el-icon-arrow-down"/>
                  </div>
                  <b class="menuCount" v-if="list.count">{{list.count}}</b>
                  <b :class="b2Data.indexOf(list.path)>-1?'b1':'b2'" v-if="newData.indexOf(list.path)>-1">{{b2Data.indexOf(list.path)>-1?$t('sidebar.newBadge'):''}}</b>
                </div>
                <div class="childrenBox" v-if="list.expand">
                  <div class="childrenBoxList" @click="goPath(el)" v-for="el in list.children" :class="{active:ActivePath===el.path}">
                    <ElThTooltip :placement="'right'" :data="el.textLiteral || menu[el.text]"/>
<!--                <b class="b2" v-if="newData.indexOf(el.path)>-1"></b>-->
                    <b v-if="el.path==='/NeedsAttention' && needsAttentionCount>0" class="attention-badge">{{needsAttentionCount > 99 ? '99+' : needsAttentionCount}}</b>
                  <b v-else-if="newData.indexOf(el.path)>-1" :class="b2Data.indexOf(el.path)>-1?'b1':'b2'">{{b2Data.indexOf(el.path)>-1?$t('sidebar.newBadge'):''}}</b>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </transition-group>
      </div>
    </transition>
    <transition name="rm-collapse">
      <div v-if="!effectiveShowSider" key="collapsed">
        <!-- Collapsed module switcher: single icon + popover -->
        <el-popover v-if="availableModuleCount > 1" placement="right-start" trigger="click" popper-class="collapseModulePopper" v-model="moduleSwitchVisible">
          <div slot="reference" class="collapse-module-entry">
            <SvgIcon :iconClass="activeModule === 'restaurant' ? 'Restaurant' : 'dashboard'" />
          </div>
          <div class="collapse-module-list">
            <div v-if="hasHotel" class="collapse-module-option" :class="{active: activeModule === 'hotel'}" @click="switchModule('hotel'); moduleSwitchVisible = false">
              <SvgIcon iconClass="dashboard" />
              <span>{{menu['Hotel'] || 'Hotel'}}</span>
              <i v-if="activeModule === 'hotel'" class="el-icon-check"></i>
            </div>
            <div v-if="hasRestaurant" class="collapse-module-option" :class="{active: activeModule === 'restaurant'}" @click="switchModule('restaurant'); moduleSwitchVisible = false">
              <SvgIcon iconClass="Restaurant" />
              <span>{{menu['F&B'] || 'F&B'}}</span>
              <i v-if="activeModule === 'restaurant'" class="el-icon-check"></i>
            </div>
            <div v-if="hasBrand" class="collapse-module-option" :class="{active: activeModule === 'brand'}" @click="switchModule('brand'); moduleSwitchVisible = false">
              <SvgIcon iconClass="dashboard" />
              <span>{{menu['Brand'] || 'Brand'}}</span>
              <i v-if="activeModule === 'brand'" class="el-icon-check"></i>
            </div>
          </div>
        </el-popover>
        <div v-for="item in activeHidePathData">
          <div v-if="item.type==='slider'" class="hideSliderBox"></div>
          <div v-else>
            <el-popover placement="right-start" trigger="hover" :popper-class="item.padding?'hidePopperClass hidePopperClass1':'hidePopperClass'">
              <div slot="reference" class="hidePathList" :class="{hideActiveClass:hideActivePath === item.icon, 'intelligence-hide':item.icon==='ai-chat'}"><AiChatIcon v-if="item.icon==='ai-chat'" /><SvgIcon v-else :iconClass="item.icon"/><b class="newLabel1" v-if="countHideNewLabel(item)"></b></div>
              <div v-for="list in item.data">
                <div class="title" @click="goPath(list)" :class="{active:isMenuRowActive(list)}">{{ list.titleLiteral || menu[list.title] }}<b class="newLabel" v-if="newData.indexOf(list.path)>-1">{{ $t('sidebar.newBadge') }}</b></div>
                <div v-if="list.children" v-for="el in list.children" class="childrenBox" @click="goPath(el)"
                     :class="{active: ActivePath === el.path}">{{ el.titleLiteral || menu[el.title] }}<b v-if="el.path==='/NeedsAttention' && needsAttentionCount>0" class="attention-badge">{{needsAttentionCount > 99 ? '99+' : needsAttentionCount}}</b><b class="newLabel" v-else-if="newData.indexOf(el.path)>-1">{{ $t('sidebar.newBadge') }}</b></div>
              </div>
            </el-popover>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>


<script>
import SvgIcon from "@/components/SvgIcon/index.vue";
import {mapState, mapGetters} from "vuex";
import ElThTooltip from "@/views/competitors/components/ElThTooltip.vue";
import { isPathEnabled, isPathEnabledForHotel, isFeatureEnabled, isMenuPathEnabled, isRestaurantMenuPathEnabled, isLuxuryStandardsHotel } from "@/utils/featureGates";
import AiChatIcon from "@/components/common/AiChatIcon.vue";
import { PENDING_HOTEL_ID_KEY, HOTEL_BEFORE_BRAND_KEY } from "@/utils/pendingHotelSwitch";
import { clusterForHotel, firstHotelOfCluster } from "@/utils/cluster";
import { BRAND_NAME_ALIASES, portfolioCountryOf, portfolioTitleFor } from "@/views/BrandOverview2/utils/bo2Helpers.js";

export default {
  name: 'RouterMenu',
  components: {ElThTooltip, SvgIcon, AiChatIcon,},
  data(){
    return {
      activeModule: 'hotel',
      moduleSwitchVisible: false,
      // 展开态：在这张表里的显示 "New" 胶囊，其余 newData 里的只显示小圆点
      b2Data:['/setting','/Survey/DuringStay','/Survey/PostStay','/MarketHalfYear','/QualityStandards','/HalfYearReview','/FnbHalfYear'],
      // 酒店模块菜单
      hotelPathData:[
        {
          data:[
            {
              icon:'dashboard',
              text:'Hotel Overview',
              path:'/index',
            },
          ],
        },
        {
          title:'Hotel Reviews',
          data:[
            {
              icon:'reviews',
              text:'Reviews',
              path:'/reviews',
            },
            {
              icon:'needs-attention',
              text:'Case Management',
              path:'/NeedsAttention',
            },
            {
              icon:'reply-setting',
              text:'Reply Setting',
              path:'/ReplySetting',
            },
            {
              icon:'reply-library',
              text:'Reply Library',
              path:'/ReplyLibrary',
            },
          ],
        },
        {
          title:'Competition',
          data:[
            {
              icon:'market-overview',
              text:'Competitors_OTA_Reports',
              path:'/competitors/overview',
            },
            {
              icon:'Competition',
              text:'Competitors_Benchmarks',
              path:'/competitors/analysis',
            },
            // 只在 Kimpton Maa-Lai Bangkok 下出现（featureGates.js 的 HOTEL_ONLY_PATHS）。
            {
              icon:'market-signals',
              text:'Market Signals',
              path:'/MarketHalfYear',
            },
          ],
        },
        {
          title:'Insights',
          data:[
            {
              icon:'reports',
              text:'Reports',
              path:'/Reports',
            },
            // 只在 Kimpton Maa-Lai Bangkok 和演示酒店 Grand Luxury 下出现，不看接口 menu（featureGates.js 的 HOTEL_ONLY_PATHS）。
            {
              icon:'quality-standards',
              text:'Quality Standards',
              path:'/QualityStandards',
            },
            // 只在 Kimpton Maa-Lai Bangkok 和演示酒店 Grand Luxury 下出现（featureGates.js 的 HOTEL_ONLY_PATHS）。
            {
              icon:'half-year-review',
              text:'Period Review',
              path:'/HalfYearReview',
            },
            // Brand Overview / Portfolio Insights 暂时从侧栏隐藏（2026-09 产品决定）。
            // 路由本身还在，直接输 URL 仍能打开，所以这里注释掉而不是删。
            // {
            //   icon:'BrandOverview',
            //   text:'Brand Overview',
            //   path:'/BrandOverview',
            // },
            // {
            //   icon:'BrandOverview',
            //   text:'BrandOverview2',
            //   path:'/BrandOverview2',
            // },
          ],
        },
        {
          title:'Surveys',
          data:[
            {
              icon:'survey-during-stay',
              text:'During Stay',
              path:'/Survey/DuringStay',
            },
            {
              icon:'survey-post-stay',
              text:'Post Stay',
              path:'/Survey/PostStay',
            },
            {
              icon:'survey-detail',
              text:'Survey Detail',
              path:'/Survey/Detail',
            },
          ],
        },
      ],
      // 餐厅模块菜单
      restaurantPathData:[
        {
          data:[
            {
              icon:'Restaurant',
              text:'Restaurant Overview',
              path:'/RestaurantDashboard',
            },
          ],
        },
        {
          title:'Restaurant Reviews',
          data:[
            {
              icon:'reviews',
              text:'F&B Reviews',
              path:'/RestaurantReviewsIndex',
            },
            {
              icon:'needs-attention',
              text:'Case Management',
              path:'/NeedsAttention',
            },
            {
              icon:'reply-setting',
              text:'Reply Setting',
              path:'/ReplySetting',
            },
            {
              icon:'reply-library',
              text:'Reply Library',
              path:'/ReplyLibrary',
            },
          ],
        },
        {
          title:'Competition',
          data:[
            {
              icon:'market-overview',
              text:'Competitors_OTA_Reports',
              path:'/competitors/overview',
            },
            {
              icon:'Competition',
              text:'Competitors_Benchmarks',
              path:'/competitors/analysis',
            },
          ],
        },
        {
          title:'Insights',
          data:[
            // {
            //   icon:'reports',
            //   text:'Reports',
            //   path:'/Reports',
            // },
            {
              icon:'reports',
              text:'Reports',
              path:'/Reports',
            },
            {
              icon:'reports',
              text:'PortiolioBriefing',
              path:'/PortfolioBriefing',
            },
            // 只在 Kimpton Maa-Lai Bangkok 和演示酒店 Grand Luxury 下出现（featureGates.js 的 HOTEL_ONLY_PATHS）。
            {
              icon:'half-year-review',
              text:'Half-Year Review',
              path:'/FnbHalfYear',
            },
            // {
            //   icon:'BrandOverview',
            //   text:'Brand Overview',
            //   path:'/BrandOverview',
            // },
          ],
        },
      ],
      // 共用菜单（始终显示）
      sharedPathData:[
        {
          title:'Generals',
          data:[
            {
              icon:'set',
              text:'Setting',
              path:'/setting',
            },
            {
              icon:'FAQ',
              text:'Help Center (FAQ)',
              path:'/FAQ',
            },
          ],
        },
      ],
      showPathData:[], // kept for compatibility
      // 酒店模块收起菜单
      hotelHidePathData:[
        {
          icon:'dashboard',
          data:[
            {
              title:"Hotel Overview",
              path:"/index",
            }
          ],
        },
        {
          type:'slider',
        },
        {
          icon:'reviews',
          padding:true,
          data:[
            {
              title:"Hotel Reviews",
              children:[
                {
                  title:'Reviews',
                  path:'/reviews',
                },
                {
                  title:'Case Management',
                  path:'/NeedsAttention',
                },
                {
                  title:'Reply Setting',
                  path:'/ReplySetting',
                },
                {
                  title:'Reply Library',
                  path:'/ReplyLibrary',
                },
              ],
            },
          ],
        },
        {
          type:'slider',
        },
        {
          icon:'Competition',
          data:[
            {
              title:"Competition",
              children:[
                {
                  title:'Competitors_OTA_Reports',
                  path:'/competitors/overview',
                },
                {
                  title:'Competitors_Benchmarks',
                  path:'/competitors/analysis',
                },
                // 只在 Kimpton Maa-Lai Bangkok 下出现（featureGates.js 的 HOTEL_ONLY_PATHS）。
                {
                  title:'Market Signals',
                  path:'/MarketHalfYear',
                },
              ],
            },
          ],
        },
        {
          type:'slider',
        },
        {
          icon:'reports',
          data:[
            {
              title:"Reports",
              path:'/Reports',
            }
          ],
        },
        // 只在 Kimpton Maa-Lai Bangkok 和演示酒店 Grand Luxury 下出现，不看接口 menu（featureGates.js 的 HOTEL_ONLY_PATHS）。
        {
          icon:'quality-standards',
          data:[
            {
              title:"Quality Standards",
              path:'/QualityStandards',
            }
          ],
        },
        // 只在 Kimpton Maa-Lai Bangkok 和演示酒店 Grand Luxury 下出现（featureGates.js 的 HOTEL_ONLY_PATHS）。
        {
          icon:'half-year-review',
          data:[
            {
              title:"Period Review",
              path:'/HalfYearReview',
            }
          ],
        },
        {
          icon:'survey-during-stay',
          data:[
            {
              title:"During Stay",
              path:'/Survey/DuringStay',
            },
            {
              title:"Post Stay",
              path:'/Survey/PostStay',
            },
            {
              title:"Survey Detail",
              path:'/Survey/Detail',
            },
          ],
        },
        // 与展开态一致：Brand Overview / Portfolio Insights 暂时隐藏。
        // {
        //   icon:'BrandOverview',
        //   data:[
        //     {
        //       title:"Brand Overview",
        //       path:'/BrandOverview',
        //     },
        //     {
        //       title:"BrandOverview2",
        //       path:'/BrandOverview2',
        //     },
        //   ],
        // },
      ],
      // 餐厅模块收起菜单
      restaurantHidePathData:[
        {
          icon:'Restaurant',
          data:[
            {
              title:"Restaurant Overview",
              path:"/RestaurantDashboard",
            }
          ],
        },
        {
          type:'slider',
        },
        {
          icon:'reviews',
          padding:true,
          data:[
            {
              title:"Restaurant Reviews",
              children:[
                {
                  title:'F&B Reviews',
                  path:'/RestaurantReviewsIndex',
                },
                {
                  title:'Case Management',
                  path:'/NeedsAttention',
                },
                {
                  title:'Reply Setting',
                  path:'/ReplySetting',
                },
                {
                  title:'Reply Library',
                  path:'/ReplyLibrary',
                },
              ],
            },
          ],
        },
        {
          type:'slider',
        },
        {
          icon:'Competition',
          data:[
            {
              title:"Competition",
              children:[
                {
                  title:'Competitors_OTA_Reports',
                  path:'/competitors/overview',
                },
                {
                  title:'Competitors_Benchmarks',
                  path:'/competitors/analysis',
                },
              ],
            },
          ],
        },
        {
          type:'slider',
        },
        {
          icon:'reports',
          data:[
            {
              title:"Reports",
              path:'/Reports',
            }
          ],
        },
        // 只在 Kimpton Maa-Lai Bangkok 和演示酒店 Grand Luxury 下出现（featureGates.js 的 HOTEL_ONLY_PATHS）。
        {
          icon:'half-year-review',
          data:[
            {
              title:"Half-Year Review",
              path:'/FnbHalfYear',
            }
          ],
        },
        // {
        //   icon:'BrandOverview',
        //   data:[
        //     {
        //       title:"Brand Overview",
        //       path:'/BrandOverview',
        //     }
        //   ],
        // },
      ],
      // 共用收起菜单（Setting & Staff Management & FAQ）
      sharedHidePathData:[
        {
          type:'slider',
        },
        {
          icon:'set',
          data:[
            {
              title:"Setting",
              path:'/setting',
            }
          ],
        },
        {
          icon:'FAQ',
          data:[
            {
              title:"Help Center (FAQ)",
              path:'/FAQ',
            }
          ],
        },
      ],
      tabScrolled: false,
      ActivePath:'',
      hideActivePath:'',
    }
  },
  mounted() {
    this.$el.addEventListener('scroll', this.handleSidebarScroll);
  },
  beforeDestroy() {
    this.$el.removeEventListener('scroll', this.handleSidebarScroll);
  },
  created() {
    this.ActivePath = this.$route.path
    if (this.isBrandMode) {
      // 品牌模式：不联动 hotel/isHotel，保留切换回酒店/餐厅模式前的状态
      this.activeModule = 'brand';
      document.documentElement.setAttribute('data-module', 'brand');
    } else {
      // 根据当前路由自动选择模块
      var restaurantPaths = ['/RestaurantDashboard', '/RestaurantReviewsIndex'];
      if (restaurantPaths.indexOf(this.$route.path) > -1 || !this.$store.state.hotel.isHotel) {
        this.activeModule = 'restaurant';
        this.$store.commit('hotel/SET_IS_HOTEL', false);
      } else {
        this.activeModule = 'hotel';
        this.$store.commit('hotel/SET_IS_HOTEL', true);
      }
      document.documentElement.setAttribute('data-module', this.activeModule);
    }

    this.fetchAttentionCount()
    this.$store.dispatch('auth/fetchEntities')
  },
  computed:{
    ...mapState({
      isShowSider:state => state.hotel.isShowSider,
      isMobileNav:state => state.hotel.isMobileNav,
      currentHotelId:state => state.hotel.currentHotelId,
      needsAttentionCount:state => state.hotel.needsAttentionCount,
      hasRestaurant:state => state.hotel.hasRestaurant,
      selectedRestaurantId:state => state.restaurant.selectedRestaurantId,
      isHotel:state => state.hotel.isHotel,
      isBrandMode:state => !!state.auth.selectedBrandName,
      hotelList:state => state.hotel.hotelList,
      restaurantList:state => state.restaurant.restaurantList,
      brandList:state => state.auth.brands,
      // Reported by BrandOverview2/index.vue itself (see brandNav.js) — the
      // sidebar never fetches this on its own, so it can't drift from
      // whatever the page's own "All brands" table is showing.
      groupBrands:state => state.brandNav.groupBrands,
      viewingBrandKey:state => state.brandNav.activeBrandKey,
      viewingBrandViewMode:state => state.brandNav.activeBrandViewMode,
      viewingDrillKey:state => state.brandNav.activeDrillKey,
    }),
    // Same "does this account have more than one module to choose from" gate
    // as HotelSelector.vue's post-login picker — the tab strip (and each
    // individual tab) only shows a module the account actually has.
    hasHotel() {
      return (this.hotelList || []).length > 0;
    },
    hasBrand() {
      return (this.brandList || []).length > 0;
    },
    availableModuleCount() {
      return [this.hasHotel, this.hasRestaurant, this.hasBrand].filter(Boolean).length;
    },
    activeBrandName() {
      return this.$store.state.auth.selectedBrandName;
    },
    currentBrandRecord() {
      return (this.brandList || []).find((b) => b.name === this.activeBrandName) || null;
    },
    // 品牌模式下选中的 cluster 只有一个品牌（报告走 /cluster/brand，页面没有一级组合页，见 BrandOverview2）
    isSingleBrandCluster() {
      return !!(this.currentBrandRecord && (this.currentBrandRecord.brands || []).length === 1);
    },
    // Top-of-menu label for brand mode — falls back to the plain "Portfolio
    // Insights" translation if this brand carries no hotelGroup (or isn't
    // found at all, e.g. mid-switch).
    brandOverviewLabel() {
      const group = this.currentBrandRecord && this.currentBrandRecord.hotelGroup;
      // IHG's demo scope here is specifically the Thailand luxury portfolio
      // (see IHGLQAMock.js's "IHG Thailand" group), not the whole hotel
      // group worldwide — the generic "{group} Overview" template overstates it.
      // 集团名是数据，只翻译「概览」这部分
      // 只有配置过的「集团 + 国家」才用专属名称（bo2Helpers 的 PORTFOLIO_TITLES，目前只有 IHG 泰国）；
      // 国家从当前品牌和品牌页上报的品牌列表推，IHG 其他国家的组合回到通用的 "{group} Overview"。
      if (group === 'IHG') {
        const brandNames = Object.keys(this.groupBrands || {});
        if (this.currentBrandRecord) brandNames.push(this.currentBrandRecord.name);
        const config = portfolioTitleFor('IHG', portfolioCountryOf(brandNames));
        if (config) return this.$t(config.sidebarKey);
      }
      return group ? this.$t('sidebar.groupOverview', { group }) : (this.menu['BrandOverview2'] || 'Portfolio Insights');
    },
    // "All brands", sidebar-weight version — name + property count, no status/
    // score (those still need BrandOverview2's own heavier computeds). Sourced
    // from BrandOverview2/index.vue's own groupData.brands, reported into
    // brandNav (see store/modules/brandNav.js) once that page's own 3 API
    // calls resolve — the sidebar never fetches this itself, so it can't
    // desync from the "All brands" table that reads the very same object.
    // Each brand renders as two plain, clickable rows back to back — its
    // Overview (unchanged) and its Details tab — rather than one row with a
    // "children" (isPortfolioOverview elsewhere here already means goPath's
    // `if (data.children)` branch would just toggle an expand state instead
    // of navigating, which is wrong for a row whose whole point IS the click).
    brandMenuChildren() {
      if (!this.groupBrands) return [];
      const rows = [];
      Object.entries(this.groupBrands)
        .filter(([, brand]) => brand)
        .map(([key, brand]) => ({
          key,
          displayName: this.brandDisplayName(key),
          propertyCount: Object.keys(brand.hotel_map || {}).length,
        }))
        .sort((a, b) => (a.displayName || '').localeCompare(b.displayName || '', undefined, { sensitivity: 'base' }))
        .forEach(({ key, displayName, propertyCount }) => {
          rows.push({
            count: propertyCount,
            title: displayName,
            // 收起态的浮层里没有右侧计数那一列，直接并进文字
            titleLiteral: propertyCount ? `${displayName} · ${propertyCount}` : displayName,
            text: displayName,
            textLiteral: displayName,
            path: '/BrandOverview2',
            brandKey: key,
          });
          // 品牌名是数据，只翻译「详情」这部分
          const detailsLabel = this.$t('sidebar.brandDetails', { brand: displayName });
          rows.push({
            title: `${displayName} details`,
            titleLiteral: detailsLabel,
            text: `${displayName}Details`,
            textLiteral: detailsLabel,
            path: '/BrandOverview2',
            brandKey: key,
            isBrandDetailsLink: true,
          });
        });
      return rows;
    },
    // True while we know this brand belongs to a group (so a "Brand Overview"
    // section IS coming) but BrandOverview2/index.vue's own report hasn't
    // resolved yet — lets brandModePathData show skeleton placeholder rows
    // instead of just omitting the section, which otherwise reads as the
    // sidebar "forgetting" it entirely until the page's data lands and the
    // whole section pops in at once.
    isBrandOverviewLoading() {
      const group = this.currentBrandRecord && this.currentBrandRecord.hotelGroup;
      return !!group && !this.groupBrands;
    },
    // Brand mode's own minimal menu — deliberately NOT hotelPathData's
    // Competition/Insights/Surveys sections (those stay hotel/restaurant-only
    // even for an account that happens to have access): just the renamed top
    // item, plus a "Brand Overview"-labeled section listing each brand as its
    // own row — the section only appears once groupBrands has actually
    // resolved to real brand entries (see brandMenuChildren above), not
    // merely "the request returned something" (an empty {"brands": {}}
    // response would otherwise pass a plain != null check and show an empty,
    // label-only section).
    brandModePathData() {
      // 单品牌 cluster 没有一级（组合）页：不出顶上的组合总览和 Active Signal Details，只列这个品牌
      const sections = this.isSingleBrandCluster ? [] : [
        {
          data: [
            {
              text: 'BrandOverview2',
              textLiteral: this.brandOverviewLabel,
              path: '/BrandOverview2',
              isPortfolioOverview: true,
            },
            {
              // 文案走 menu.ActiveSignalDetails
              text: 'ActiveSignalDetails',
              path: '/BrandOverview2',
              isActiveSignalDetails: true,
              dutyKey: 'hotel_operations',
            },
          ],
        },
      ];
      if (this.brandMenuChildren.length) {
        sections.push({
          title: 'BrandOverviewList',
          data: this.brandMenuChildren,
        });
      } else if (this.isBrandOverviewLoading) {
        sections.push({
          title: 'BrandOverviewList',
          data: [
            { loading: true, width: '80%' },
            { loading: true, width: '55%' },
            { loading: true, width: '85%' },
            { loading: true, width: '60%' },
          ],
        });
      }
      return sections;
    },
    // Collapsed/icon-rail counterpart of brandModePathData above. The label
    // row keeps children:[] purely so goPath's `if (data.children)` branch
    // treats a click on it as an inert toggle — same as hotelHidePathData's
    // own label-only "Hotel Reviews" row already does — instead of falling
    // through to router.push with no .path; the real brand rows are its
    // siblings here, not nested under it.
    brandModeHidePathData() {
      // 同上：单品牌 cluster 不出组合总览和 Active Signal Details
      const sections = this.isSingleBrandCluster ? [] : [
        {
          icon: 'dashboard',
          data: [
            { title: 'BrandOverview2', titleLiteral: this.brandOverviewLabel, path: '/BrandOverview2', isPortfolioOverview: true },
            { title: 'ActiveSignalDetails', path: '/BrandOverview2', isActiveSignalDetails: true, dutyKey: 'hotel_operations' },
          ],
        },
      ];
      if (this.brandMenuChildren.length) {
        sections.push({
          icon: 'reviews',
          padding: true,
          data: [
            { title: 'BrandOverviewList', titleLiteral: this.menu['BrandOverviewList'] || 'Brand Overview', children: [] },
            ...this.brandMenuChildren,
          ],
        });
      }
      return sections;
    },
    // Brand-only accounts have no hotelId/restaurantId, so none of the
    // hotel/restaurant-specific pages apply — the menu is just BrandOverview2
    // plus the always-shown shared items (Settings/FAQ).

    // <1024px 手机抽屉打开时始终按展开态渲染菜单（带文字），和桌面端"收起成图标条"
    // (isShowSider=false) 是两个独立的概念——同一份逻辑也用在 Sidebar/index.vue 里。
    effectiveShowSider() {
      return this.isMobileNav ? true : this.isShowSider;
    },
    currentHotelMenu() {
      const hotel = this.$store.getters['hotel/currentHotel'];
      return hotel ? hotel.menu : null;
    },
    currentRestaurantMenu() {
      const list = this.$store.state.restaurant.restaurantList;
      const restaurant = (list || []).find((r) => r.restaurantId === this.selectedRestaurantId);
      return restaurant ? restaurant.menu : null;
    },
    activeShowPathData(){
      if (this.isBrandMode) {
        var brandResult = this.brandModePathData
          .concat(this.sharedPathData)
          .map((section) => section.data
            ? { ...section, data: section.data.filter((item) => isPathEnabled(item.path) && this.isPathEnabledForCurrentHotel(item.path)) }
            : section)
          .filter((section) => !section.data || section.data.length);
        // AI Chat — brand mode skipped this pin entirely before; kept it to the
        // simpler env-only gate (isPathEnabled) rather than the module-menu gate
        // below, matching how the rest of brand mode's filtering already only
        // checks isPathEnabled (a brand-only account's currentHotelMenu may not
        // reflect what the brand itself is entitled to).
        if (isFeatureEnabled('aiChat') && isPathEnabled('/chat')) {
          brandResult = [
            { intelligence: true, data: [{ icon: 'ai-chat', text: 'AI Chat', path: '/chat' }] },
          ].concat(brandResult);
        }
        return brandResult;
      }
      var moduleData = this.activeModule === 'hotel' ? this.hotelPathData : this.restaurantPathData;
      if (!this.isHotel) {
        moduleData = moduleData.map((section) => {
          if (!section.data) return section;
          return {
            ...section,
            data: section.data.filter((item) => item.path !== '/BrandOverview'),
          };
        });
      }
      var result = moduleData.concat(this.sharedPathData);
      // Hide pages disabled in this environment OR by the current module's server-side menu.
      result = result
        .map((section) => section.data
          ? { ...section, data: section.data.filter((item) => isPathEnabled(item.path) && this.isActiveModuleMenuPathEnabled(item.path) && this.isPathEnabledForCurrentHotel(item.path)).map(this.withHotelMenuLabel) }
          : section)
        .filter((section) => !section.data || section.data.length);
      // AI Chat — pinned to the very top of the menu when enabled (env + module menu).
      if (isFeatureEnabled('aiChat') && this.isActiveModuleMenuPathEnabled('/chat')) {
        result = [
          { intelligence: true, data: [{ icon: 'ai-chat', text: 'AI Chat', path: '/chat' }] },
        ].concat(result);
      }
      return result;
    },
    activeHidePathData(){
      if (this.isBrandMode) {
        var brandHideResult = this.brandModeHidePathData
          .concat(this.sharedHidePathData)
          .filter((item) => !item.data || item.data.every((d) => isPathEnabled(d.path) && this.isPathEnabledForCurrentHotel(d.path)));
        if (isFeatureEnabled('aiChat') && isPathEnabled('/chat')) {
          brandHideResult = [
            { icon: 'ai-chat', data: [{ title: 'AI Chat', path: '/chat' }] },
            { type: 'slider' },
          ].concat(brandHideResult);
        }
        return brandHideResult;
      }
      var moduleData = this.activeModule === 'hotel' ? this.hotelHidePathData : this.restaurantHidePathData;
      if (!this.isHotel) {
        moduleData = moduleData.filter((item) => item.icon !== 'BrandOverview');
      }
      var result = moduleData.concat(this.sharedHidePathData);
      const isHidePathAllowed = (path) => isPathEnabled(path) && this.isActiveModuleMenuPathEnabled(path) && this.isPathEnabledForCurrentHotel(path);
      // 图标条的分组项（如 Competition）真正的页面在 children 里，分组本身没有 path，
      // 上面那层 every() 对它恒为 true —— 不单独筛 children 的话，只对 Kimpton Maa-Lai Bangkok 开放的
      // Local market signals（/MarketHalfYear）会在所有酒店的收起侧边栏里露出来。
      result = result.map((item) => (item.data && item.data.some((d) => d.children && d.children.length)
        ? { ...item, data: item.data.map((d) => (d.children ? { ...d, children: d.children.filter((c) => isHidePathAllowed(c.path)) } : d)) }
        : item));
      // Hide pages disabled in this environment OR by the current module's server-side menu.
      result = result.filter((item) => !item.data || item.data.every((d) => isHidePathAllowed(d.path)))
        .map((item) => (item.data ? { ...item, data: item.data.map(this.withHotelMenuLabel) } : item));
      // AI Chat — pinned to the top of the icon rail when enabled (env + module menu).
      if (isFeatureEnabled('aiChat') && this.isActiveModuleMenuPathEnabled('/chat')) {
        result = [
          { icon: 'ai-chat', data: [{ title: 'AI Chat', path: '/chat' }] },
          { type: 'slider' },
        ].concat(result);
      }
      return result;
    },
    newData(){
      // Reports（原来每周一、二显示）和 Reply Library（原来常驻）的 New 于 2026-09-29 按产品要求去掉
      const paths = [];
      // Show "New" on Survey for 14 days after launch (2026-05-26)
      const surveyLaunch = new Date('2026-05-26');
      if ((Date.now() - surveyLaunch.getTime()) / 86400000 < 14) {
        paths.push('/Survey/DuringStay', '/Survey/PostStay');
      }
      // Show "New" on the half-year reports / market signals / quality standards for 30 days
      // after launch (2026-09-29). 这几项本身只对特定酒店/餐厅可见（featureGates.js 的
      // HOTEL_ONLY_PATHS / RESTAURANT_ENTITY_ONLY_PATHS），看不到菜单的账号也就看不到 New。
      const halfYearLaunch = new Date('2026-09-29');
      if ((Date.now() - halfYearLaunch.getTime()) / 86400000 < 30) {
        paths.push('/MarketHalfYear', '/QualityStandards', '/HalfYearReview', '/FnbHalfYear');
      }
      return paths;
    },
    menu(){
      return this.$t('menu')
    },
    path(){
      return this.$route.path
    },
  },
  watch:{
    path:{
      handler(newV){
        if(newV){
          this.ActivePath = newV;
          this.getIconByPath(this.activeHidePathData);
        }
      },
      immediate: true,
    },
    currentHotelId(){
      this.fetchAttentionCount()
    },
    selectedRestaurantId(){
      this.fetchAttentionCount()
    },
    // 品牌模式的收起态图标高亮不跟路由变（路由一直是 /BrandOverview2），只跟"当前
    // 看的是组合总览还是某个品牌"变——见 getIconByPath 的品牌模式分支。
    viewingBrandKey(){
      if (this.isBrandMode) this.getIconByPath(this.activeHidePathData);
    },
  },
  methods:{
    handleSidebarScroll(e) {
      this.tabScrolled = e.target.scrollTop > 0;
    },
    // Whether a top-level brand-mode row (list in the v-for above) should
    // render as active. Pulled out of the template because it's grown past
    // what's readable as one inline expression: the "{hotelGroup} Overview" /
    // "Active Signal Details" / per-brand Overview / per-brand Details rows
    // all share the same /BrandOverview2 path, so ActivePath alone can't tell
    // them apart — only BrandOverview2/index.vue's own reported state
    // (viewingBrandKey/viewingBrandViewMode/viewingDrillKey) can.
    isMenuRowActive(list) {
      if (this.ActivePath !== list.path) return false;
      if (list.isPortfolioOverview) return !this.viewingBrandKey && !this.viewingDrillKey;
      if (list.isActiveSignalDetails) return !this.viewingBrandKey && this.viewingDrillKey === list.dutyKey;
      if (list.brandKey) {
        if (this.viewingBrandKey !== list.brandKey) return false;
        return list.isBrandDetailsLink
          ? this.viewingBrandViewMode === 'details'
          : this.viewingBrandViewMode !== 'details';
      }
      return true;
    },
    // Server-side menu gate, resolved against whichever module (hotel/restaurant) is active —
    // each module's server menu reuses the same `type` vocabulary for different route paths.
    isActiveModuleMenuPathEnabled(path) {
      return this.activeModule === 'restaurant'
        ? isRestaurantMenuPathEnabled(path, this.currentRestaurantMenu)
        : isMenuPathEnabled(path, this.currentHotelMenu);
    },
    // 只为特定酒店准备的页面（featureGates.js 的 HOTEL_ONLY_PATHS）。品牌模式下没有
    // 「当前酒店」，hotelName 取不到 -> 这类菜单项一律不出，正是想要的默认。
    // /FnbHalfYear 另按「当前选中的餐厅」的 hotelName 来定（featureGates.js 的 RESTAURANT_ENTITY_ONLY_PATHS）。
    // /QualityStandards 同一个入口分两版：看新版 WTK Luxury Standards 的酒店（featureGates.js 的
    // LUXURY_STANDARDS_HOTELS）侧栏显示 "Luxury Standards / 奢华服务标准"，其余仍是 "Quality Standards / 质量标准"。
    // 展开和收起的侧栏分别读 textLiteral / titleLiteral，两个都给。
    withHotelMenuLabel(item) {
      if (!item || item.path !== '/QualityStandards') return item;
      const hotel = this.$store.getters["hotel/currentHotel"];
      if (!isLuxuryStandardsHotel(hotel && hotel.hotelName)) return item;
      const label = this.menu['Luxury Standards'];
      return { ...item, textLiteral: label, titleLiteral: label };
    },
    isPathEnabledForCurrentHotel(path) {
      const hotel = this.$store.getters["hotel/currentHotel"];
      return isPathEnabledForHotel(path, hotel && hotel.hotelName, this.$store.getters["restaurant/currentRestaurant"]);
    },
    // 侧边栏 Case Management 角标：和该页默认时间范围一致，最近一个月（含今天 30 天）
    fetchAttentionCount(){
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
      const fmt = d => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
      this.$store.dispatch('hotel/fetchNeedsAttentionCount', {
        startDate: fmt(start),
        endDate: fmt(end),
      });
    },
    countHideNewLabel(data){
      return data.data.some(item => {
        return item.children
            ? item.children.some(child => child.path && this.newData.includes(child.path))
            : item.path && this.newData.includes(item.path)
      })
    },
    switchModule(module) {
      if (this.activeModule === module) {
        return;
      }
      const leavingBrandMode = this.isBrandMode;
      if (leavingBrandMode) {
        // 退出品牌模式：清空所选品牌，并自动选中目标模式下的酒店/餐厅。
        // 先把刚才看的是哪个品牌记下来 —— 下面挑酒店要用，清空之后就取不到了。
        const leavingBrandName = this.$store.state.auth.selectedBrandName;
        const leavingBrand = (this.brandList || []).find((b) => b.name === leavingBrandName) || null;
        this.$store.commit('auth/SET_SELECTED_BRAND', null);
        if (module === 'hotel') {
          const sortedHotels = [...this.hotelList].sort((a, b) =>
            (a.hotelName || '').localeCompare(b.hotelName || '', undefined, { sensitivity: 'base' })
          );
          // 和进品牌模式那边对称：优先回到刚才那个品牌旗下的酒店，而不是按名称排第一的。
          // 优先级从高到低：
          //   1. 当前酒店本来就属于这个品牌 —— 原地不动，从哪进来就回哪去
          //   2. 该品牌旗下任意一家（按名称排序取第一家，保证结果稳定）
          //   3. 同集团任意一家（品牌名对不上时至少别跳到别的集团去）
          //   4. 全部酒店里的第一家（原有约定）
          const brandKey = this.fuzzyBrandKey(leavingBrand ? leavingBrand.name : leavingBrandName);
          const brandDisplayKey = leavingBrand
            ? this.fuzzyBrandKey(this.brandDisplayName(leavingBrand.name))
            : '';
          const inBrand = (h) => {
            const key = this.fuzzyBrandKey(h.brand);
            return !!key && (key === brandKey || (!!brandDisplayKey && key === brandDisplayKey));
          };
          const currentHotel = this.$store.getters['hotel/currentHotel'];
          // 0. 进品牌模式前正在看的酒店（WTK-672）：只要它还在可选列表里，就原样回去
          let originHotelId = null;
          try { originHotelId = sessionStorage.getItem(HOTEL_BEFORE_BRAND_KEY); } catch (e) { /* 隐私模式下读不到就按下面的规则挑 */ }
          try { sessionStorage.removeItem(HOTEL_BEFORE_BRAND_KEY); } catch (e) { /* ignore */ }
          const originHotel = originHotelId
            ? sortedHotels.find((h) => String(h.hotelId) === String(originHotelId))
            : null;
          // 1.5 刚才那个 cluster 里的酒店（cluster.hotels），比按品牌名猜更准
          const inLeavingCluster = leavingBrand
            ? (h) => (leavingBrand.hotels || []).some((x) => x && String(x.hotelId) === String(h.hotelId))
            : () => false;
          const target = originHotel
            || (currentHotel && (inLeavingCluster(currentHotel) || inBrand(currentHotel)) ? currentHotel : null)
            || sortedHotels.find(inLeavingCluster)
            || sortedHotels.find(inBrand)
            || (leavingBrand && leavingBrand.hotelGroup
              ? sortedHotels.find((h) => h.hotelGroup === leavingBrand.hotelGroup)
              : null)
            || sortedHotels[0];
          // 这里不直接 commit hotel/SET_CURRENT_HOTEL —— BrandOverview2 还没卸载，同步改
          // currentHotelId 会触发它的 watcher 提前多发一次请求（品牌态已清空，容易报错）。
          // 存到 sessionStorage，交给 store/index.js 在整页刷新后的新会话里读取并 commit。
          if (target) sessionStorage.setItem(PENDING_HOTEL_ID_KEY, target.hotelId);
        } else {
          const first = [...this.restaurantList].sort((a, b) =>
            (a.restaurantName || '').localeCompare(b.restaurantName || '', undefined, { sensitivity: 'base' })
          )[0];
          if (first) this.$store.commit('restaurant/SET_selectedRestaurantId', first.restaurantId);
        }
      } else if (module === 'brand') {
        // 进入品牌模式先挑一个品牌。BrandOverview2 此时还没挂载，可以直接 commit
        // currentHotelId，不用像上面 leavingBrandMode 分支那样绕道 sessionStorage。
        const sortedBrands = [...this.brandList].sort((a, b) =>
          (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' })
        );
        // 优先选中当前酒店自己的品牌（hotel.brand ↔ brands[].name）：用户刚在看
        // Kimpton Maa-Lai Bangkok，切过去自然是想看 Kimpton，而不是按字母序排第一的品牌。
        // 名字两边压成纯小写字母数字再比，避免大小写/空格差异对不上。
        const currentHotel = this.$store.getters['hotel/currentHotel'];
        // 记下进来前看的酒店，退出品牌模式时还原（WTK-672）。
        if (currentHotel && currentHotel.hotelId != null) {
          try { sessionStorage.setItem(HOTEL_BEFORE_BRAND_KEY, String(currentHotel.hotelId)); } catch (e) { /* ignore */ }
        }
        const currentBrandKey = this.fuzzyBrandKey(currentHotel && currentHotel.brand);
        // 先找当前酒店所在的 cluster（cluster.hotels 里有它，或它的品牌在 cluster.brands 里）；
        // 找不到再按名字比：cluster 名多数就是品牌名本身（"EDITION Hotels"），少数带国家后缀
        //（"IHG_Thailand"，见 brandDisplayName）——两种写法都试一下。
        const matchedBrand = clusterForHotel(sortedBrands, currentHotel)
          || (currentBrandKey
            ? sortedBrands.find((b) => (
              this.fuzzyBrandKey(b.name) === currentBrandKey
              || this.fuzzyBrandKey(this.brandDisplayName(b.name)) === currentBrandKey
            ))
            : null);
        // 匹配不到就退回原来的约定：按名称排序取第一个
        //（餐厅模式切过来、纯品牌权限、或品牌名两边写法不一致时都会走这里）。
        const targetBrand = matchedBrand || sortedBrands[0];
        if (targetBrand) {
          this.$store.commit('auth/SET_SELECTED_BRAND', targetBrand.name);
          // 命中当前酒店所在的 cluster 时当前酒店本来就对，不用换；否则同 HotelSelector.vue 的
          // 品牌分支选这个 cluster 里的一家（没有就同集团的一家）。集团报告按 cluster 取，选不到也能看。
          if (!matchedBrand) {
            const matchedHotel = firstHotelOfCluster(targetBrand, this.hotelList);
            if (matchedHotel) this.$store.commit('hotel/SET_CURRENT_HOTEL', matchedHotel.hotelId);
          }
        }
      }
      // Brand mode doesn't drive hotel/isHotel — leaves whatever it was before
      // switching in, same as the isBrandMode branch elsewhere in this file.
      if (module !== 'brand') {
        this.$store.commit('hotel/SET_IS_HOTEL', module === 'hotel');
      }
      // Set data-module on html for CSS variable switching. Brand mode has its
      // own palette now, but only for the sidebar tokens — see App.vue's
      // html[data-module="brand"] block, which deliberately leaves --biz-*
      // (used page-wide) on the default hotel values.
      document.documentElement.setAttribute('data-module', module);
      localStorage.removeItem('ratingInfos');
      // Hard-navigate directly. Doing router.push().then(reload) caused a
      // visible "ghost" state where the sidebar tab style had already swapped
      // to the new module while the page content was still mid-transition
      // from the old route — combined with the 0.2s tab transition the old
      // active tab kept its biz-color tint until reload completed.
      const target = module === 'hotel' ? '/index' : module === 'restaurant' ? '/RestaurantDashboard' : '/BrandOverview2';
      this.ActivePath = target;
      // 退出品牌模式时用 replace（不留 BrandOverview2 这条历史记录），避免跳转后还能用浏览器
      // 后退键回到已经退出的品牌页面。
      if (leavingBrandMode) {
        window.location.replace(target);
      } else {
        window.location.href = target;
      }
    },
    goPath(data){
      if(data.children){
        data.expand = !data.expand
      }else if(data.isPortfolioOverview && this.isBrandMode){
        this.goToPortfolioFromMenu()
      }else if(data.isActiveSignalDetails && this.isBrandMode){
        this.goToActiveSignalDetailsFromMenu()
      }else if(data.isBrandDetailsLink && this.isBrandMode){
        this.selectBrandDetailsFromMenu(data.brandKey)
      }else if(data.brandKey && this.isBrandMode){
        this.selectBrandFromMenu(data.brandKey)
      }else{
        this.$router.push(data.path)
        this.ActivePath = data.path
      }
    },
    // Clicking a brand under "Brand Overview", or the top "{hotelGroup}
    // Overview" item — every row shares the same /BrandOverview2 path, so
    // this is SPA navigation (no reload): tell BrandOverview2/index.vue which
    // brand to show via brandNav (it applies the intent itself, whether it's
    // already mounted or about to mount — see brandNav.js/index.vue), and
    // only $router.push when we're not already on that route.
    selectBrandFromMenu(brandKey) {
      this.$store.commit('brandNav/SET_PENDING_BRAND_NAV', brandKey);
      if (this.$route.path !== '/BrandOverview2') {
        this.$router.push('/BrandOverview2');
      }
      this.ActivePath = '/BrandOverview2';
    },
    // Same as selectBrandFromMenu, plus a pending view-mode of "details" so
    // the brand lands straight on its Details tab instead of Overview —
    // the "{Brand} Details" row directly under each brand.
    selectBrandDetailsFromMenu(brandKey) {
      this.$store.commit('brandNav/SET_PENDING_BRAND_NAV', brandKey);
      this.$store.commit('brandNav/SET_PENDING_BRAND_VIEW_MODE', 'details');
      if (this.$route.path !== '/BrandOverview2') {
        this.$router.push('/BrandOverview2');
      }
      this.ActivePath = '/BrandOverview2';
    },
    // Top brand-mode menu item — "back to portfolio" is the same intent as
    // selectBrandFromMenu above, just with a null key (see SET_PENDING_BRAND_NAV).
    goToPortfolioFromMenu() {
      this.$store.commit('brandNav/SET_PENDING_BRAND_NAV', null);
      if (this.$route.path !== '/BrandOverview2') {
        this.$router.push('/BrandOverview2');
      }
      this.ActivePath = '/BrandOverview2';
    },
    // "Active Signal Details" shortcut — same SPA-nav shape as the two above,
    // except the intent BrandOverview2/index.vue applies is a portfolio-owner
    // drill (its "Hotel operations signals" page) rather than a brand. Also
    // clears any pending brand nav so a stale brand intent from an earlier
    // click can't win the race and land on that brand instead of the drill.
    goToActiveSignalDetailsFromMenu() {
      this.$store.commit('brandNav/SET_PENDING_BRAND_NAV', null);
      this.$store.commit('brandNav/SET_PENDING_DRILL_NAV', 'hotel_operations');
      if (this.$route.path !== '/BrandOverview2') {
        this.$router.push('/BrandOverview2');
      }
      this.ActivePath = '/BrandOverview2';
    },
    fuzzyBrandKey(name) {
      return String(name || "").toLowerCase().replace(/[^a-z0-9]+/g, "");
    },
    brandDisplayName(key) {
      const parts = String(key).split("_");
      const name = parts.length > 1 ? parts.slice(0, -1).join("_") : key;
      const alias = BRAND_NAME_ALIASES[this.fuzzyBrandKey(name)];
      return alias || name;
    },
    getIconByPath(data) {
      // 品牌模式下两个图标区（顶部 "{hotelGroup} Overview" 和 Brand Overview 品牌
      // 列表）共用 /BrandOverview2 这一条路由，纯 path 匹配会永远命中排在后面的那个。
      // 用"当前正在看哪个品牌"来区分，跟展开态菜单的高亮判断同源。
      if (this.isBrandMode && this.$route.path === '/BrandOverview2') {
        this.hideActivePath = this.viewingBrandKey ? 'reviews' : 'dashboard';
        return;
      }
      for (const item of data) {
        if (item.type === 'slider') continue;
        for (const dataItem of item.data) {
          if (dataItem.path && dataItem.path === this.$route.path) {
            this.hideActivePath = item.icon;
          }
          if (dataItem.children && Array.isArray(dataItem.children)) {
            const childMatch = this.matchChildrenPath(dataItem.children);
            if (childMatch) {
              this.hideActivePath = item.icon;
            }
          }
        }
      }
    },
    matchChildrenPath(children) {
      for (const child of children) {
        if (child.path && child.path === this.$route.path) {
          return true;
        }
        if (child.children && Array.isArray(child.children)) {
          const deepMatch = this.matchChildrenPath(child.children);
          if (deepMatch) {
            return true;
          }
        }
      }
      return false;
    }
  },
}
</script>

<style lang="scss" scoped>
.module-tab-wrap {
  padding: 0;
  // padding-bottom: 16px;
  margin-bottom: 8px;
  position: sticky;
  top: 0;
  z-index: 10;
  background: #fff;
  transition: box-shadow 0.2s ease;
  &--shadow {
    padding-bottom: 4px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.04);
  }
}
.module-tab {
  display: flex;
  background: #F3F4F6;
  border-radius: 8px;
  padding: 3px;
  &__item {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: 36px;
    padding: 0;
    border-radius: 6px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
    color: #6B7280;
    transition: all 0.2s ease;
    ::v-deep svg {
      width: 16px;
      height: 16px;
      color: #6B7280;
    }
    &:hover {
      color: #374151;
    }
    &.active {
      background: var(--biz-color);
      color: #FFFFFF;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
      ::v-deep svg {
        color: #FFFFFF;
      }
    }
  }
}
.collapse-module-entry {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 44px;
  border-radius: 8px;
  cursor: pointer;
  margin-bottom: 12px;
  background: var(--biz-color);
  transition: all 0.2s ease;
  ::v-deep svg {
    width: 20px;
    height: 20px;
    color: #FFFFFF;
  }
  &:hover {
    opacity: 0.85;
  }
}
.RouterMenuBox{
  margin-top: 32px;
  overflow-y: auto;
  overflow-x: clip;
  height:calc(100% - 190px);
  font-family: Inter,sans-serif;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  .showPathBoxList{
    /* Intelligence stands alone at the top, divided from the module nav below */
    &.intelligence-section{
      padding: 12px 0;
      margin-bottom: 8px;
      border-bottom: 1px solid var(--sidebar-border);
    }
    .title{
      padding: 6px 8px;
      margin-top: 12px;
      font-weight: 500;
      font-size: 13px;
      margin-bottom: 8px;
      line-height: 20px;
      color: #4B5563;
      letter-spacing: 0.06em;
    }
    .showPathListContent{
      margin-bottom: 2px;
      .showText{
        padding: 10px 14px;
        display: flex;
        align-items: center;
        justify-content:left;
        gap:8px;
        position:relative;
        cursor: pointer;
        border-radius: 8px;
        // Per-brand "Details" row, sitting directly under its brand's own
        // Overview row — same indent childrenBoxList already uses for a
        // nested item, so it visually reads as belonging to the row above it
        // instead of a same-level sibling.
        &.showText--sub{
          padding-left: 28px;
          ::v-deep .ElThTooltipBox{
            color: var(--sidebar-text-muted);
          }
        }
        // Placeholder row shown in place of a real one while its data is
        // still loading (see isBrandOverviewLoading) — same padding as
        // .showText so the section's height doesn't jump once real rows
        // replace these.
        &.showText--skeleton{
          cursor: default;
          .skeleton-bar{
            display: block;
            height: 14px;
            border-radius: 4px;
            background: var(--sidebar-hover, #F1F6F3);
            animation: skeletonPulse 1.4s ease-in-out infinite;
          }
        }
        ::v-deep svg{
          display: block;
          width: 20px;
          height: 20px;
          color: var(--sidebar-text-muted);
        }
        .menuCount{
          flex-shrink: 0;
          margin-left: auto;
          font-style: normal;
          font-weight: 400;
          font-size: 13px;
          line-height: 20px;
          color: var(--sidebar-text-subtle);
        }
        .Content_text{
          flex: 1;
          min-width: 0;
          display: flex;
          justify-content: space-between;
          align-content: center;
          i{
            transition: all 0.1s linear;
            display: block;
            width: 16px;
            height: 16px;
            transform-origin: center center;
            color: var(--sidebar-text-muted);
          }
          .expandAct{
            transform: rotate(180deg);
          }
        }
        .Content_text1{
          max-width: none;
        }
        ::v-deep .ElThTooltipBox{
          margin: 0;
          padding: 0;
          font-weight: 400;
          font-size: var(--text-base, 14px);
          line-height: 20px;
          color: var(--sidebar-text);
        }
      }
      /* "Intelligence" label: brand gradient text fill (per Figma 10962-29244) */
      .showText.intelligence-item ::v-deep .ElThTooltipBox > div{
        font-weight: 800;
        letter-spacing: 0.03em;
        background-image: linear-gradient(90deg,
          #7ABCA6 1.34%, #678CC3 23.2%, #8B5790 37%,
          #543D80 59.49%, #C97564 90.41%, #F5CE76 101.91%);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        color: transparent;
      }
      .childrenBox{
        .childrenBoxList{
          box-sizing:border-box;
          height: 36px;
          line-height: 36px;
          padding-left: 46px;
          padding-right: 14px;
          cursor: pointer;
          color: var(--sidebar-text-muted);
          position:relative;
          display: flex;
          justify-content:left;
          align-items: center;
          border-radius: 8px;
          gap:8px;
          margin-bottom: 2px;
          ::v-deep .ElThTooltipBox{
            font-size: var(--text-base, 14px);
            font-weight: 400;
            color: var(--sidebar-text-muted);
            flex: 1;
            min-width: 0;
            overflow: hidden;
          }
        }
      }
      .b1{
        flex-shrink: 0;
        margin-left: auto;
        color: var(--sidebar-accent);
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
        padding: 1px 8px;
        background: var(--biz-selected-bg);
        border-radius: 20px;
      }
      .b2{
        flex-shrink: 0;
        margin-left: auto;
        overflow: hidden;
        display: block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: var(--sidebar-text-subtle);
      }
      .attention-badge{
        flex-shrink: 0;
        margin-left: auto;
        min-width: 18px;
        height: 18px;
        padding: 0 5px;
        border-radius: 9px;
        background: #D54941;
        color: #fff;
        font-weight: 600;
        font-size: 11px;
        line-height: 18px;
        text-align: center;
        font-style: normal;
      }
      .showText:hover,.childrenBoxList:hover{
        background: var(--sidebar-hover);
        border-radius: 8px;
      }
      .active{
        background: var(--sidebar-active-bg) !important;
        border-radius: 8px;
        position:relative;
        &::before{
          content: '';
          position: absolute;
          width: 3px;
          height: 100%;
          left: 0;
          top: 0;
          border-radius: 2px;
          background: var(--sidebar-accent);
        }
        ::v-deep .ElThTooltipBox{
          color: var(--sidebar-active-text) !important;
          font-weight: 500;
        }
        .b1{
          background: var(--biz-selected-bg);
          color: var(--sidebar-accent);
        }
        .menuCount{
          color: var(--sidebar-active-text);
        }
        ::v-deep svg{
          color: var(--sidebar-accent) !important;
        }
      }
      /* Intelligence active: whole row is the brand gradient, logo + label go white.
         The animated gradient lives on ::after — the base .active rule sets
         `background:...!important` which locks background-position and would
         otherwise make the drift un-animatable. */
      .showText.intelligence-item.active{
        background: transparent !important;
        &::before{ display: none; }
        &::after{
          content: '';
          position: absolute;
          /* slightly shorter than the row so the gradient pill isn't too chunky */
          inset: 3px 0;
          z-index: 0;
          border-radius: 8px;
          background: linear-gradient(120deg,
            #7ABCA6 0%, #678CC3 20%, #8B5790 40%,
            #543D80 58%, #C97564 80%, #F5CE76 100%);
          background-size: 220% 100%;
          box-shadow: 0 2px 12px rgba(110, 81, 153, 0.30);
          animation: intelligenceShimmer 6s ease-in-out infinite alternate;
        }
        /* keep icon + label painted above the gradient layer */
        > *{ position: relative; z-index: 1; }
        /* drop the icon's gradient tile so the white "W" mark sits straight on the row */
        ::v-deep svg foreignObject{ display: none; }
        /* the bare "W" glyph only fills ~40% of its box — scale it up to match the
           cap-height of the "Intelligence" label. transform keeps the 20px layout box. */
        ::v-deep svg{ transform: scale(1.4); }
        ::v-deep .ElThTooltipBox > div{
          background-image: none !important;
          -webkit-text-fill-color: #fff !important;
          color: #fff !important;
        }
      }
      @keyframes intelligenceShimmer{
        0%{ background-position: 0% 50%; }
        100%{ background-position: 100% 50%; }
      }
      @keyframes skeletonPulse{
        0%, 100%{ opacity: 1; }
        50%{ opacity: 0.4; }
      }
      @media (prefers-reduced-motion: reduce){
        .showText.intelligence-item.active::after{ animation: none; }
      }
    }
  }
  .hideSliderBox{
    width: 100%;
    height: 1px;
    background: var(--sidebar-border);
    margin: 8px 0;
  }
  .hidePathList{
    height: 44px;
    box-sizing: border-box;
    border-radius: 8px;
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 4px;
    svg{
      display: block;
      width: 20px;
      height: 20px;
      color: var(--sidebar-text-muted);
    }
    .newLabel1{
      position: absolute;
      right: 8px;
      top: 50%;
      transform: translateY(-50%);
      display: block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: var(--sidebar-text-subtle);
    }
  }
  .hidePathList:hover{
    background: var(--sidebar-hover);
    border-radius: 8px;
  }
  .hideActiveClass{
    background: var(--sidebar-active-bg) !important;
    border-radius: 8px;
    position: relative;
    &::before{
      content: '';
      position: absolute;
      width: 3px;
      height: 100%;
      left: 0;
      top: 0;
      border-radius: 2px;
      background: var(--sidebar-accent);
    }
    svg{
      color: var(--sidebar-accent);
    }
  }
}

/* ── 品牌模式 ──
   颜色变量本身在 App.vue 的 html[data-module="brand"] 里；这里只处理那几处写死了
   --biz-color（全站通用、品牌模式刻意不改）的地方，让模块 tab 跟着变深绿。 */
html[data-module="brand"]{
  // 侧边栏本体是纯白（--sidebar-bg），tab 条用暖白把自己从底上分出来——
  // 其它模块是反过来的（浅底 + 白色 tab 条）。
  .module-tab{
    background: #ebebeb;
  }
  // sticky 吸顶时它就是菜单滚动内容的背板，必须和侧边栏同色，否则滚动时
  // 底下的菜单项会从边缘露出来。
  .module-tab-wrap{
    background: var(--sidebar-bg);
  }
  .module-tab__item.active{
    background: var(--brand-primary);
  }
  .collapse-module-entry{
    background: var(--brand-primary);
  }
  /* 选中项左侧那条竖条走品牌色（--brand-primary），不跟 --sidebar-accent（金色，brandBox 的头像圆片
     还在用它），所以在这里单独覆盖而不是改 token。 */
  .showPathBoxList .showPathListContent .active::before,
  .hideActiveClass::before{
    background: var(--brand-primary);
  }
  /* 选中项的图标同样走品牌色（原来跟着 --sidebar-accent 是金色）：展开的菜单行、收起后的图标条都一样 */
  .showPathBoxList .showPathListContent .active ::v-deep svg,
  .hideActiveClass svg{
    color: var(--brand-primary) !important;
  }
  /* 分组标题按设计稿走全大写小字号（"BRAND OVERVIEW"） */
  .showPathBoxList .title{
    text-transform: uppercase;
    font-size: 11px;
    font-weight: 600;
    color: var(--sidebar-text-subtle);
  }
}
</style>

<style>
.hidePopperClass{
  font-family: Inter,sans-serif !important;
  padding:8px !important;
  margin-top: 0 !important;
  min-width: 0 !important;
  .popper__arrow{
    display: none !important;
  }
  .title{
    height: 40px;
    line-height: 24px;
    font-weight: 700;
    font-size: 16px;
    color:#232323;
    padding: 8px;
    box-sizing: border-box;
    border-radius: 4px;
    cursor: pointer;
  }
  .newLabel{
    display: inline-block;
    margin-left: 8px;
    color: var(--sidebar-accent);
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    padding: 1px 8px;
    background: var(--biz-selected-bg);
    border-radius: 20px;
  }
  .childrenBox{
    height: 40px;
    line-height: 40px;
    padding-left: 24px;
    font-weight: 400;
    font-size: 14px;
    padding-right: 20px;
    border-radius: 4px;
    cursor: pointer;
  }
  .title:hover,  .childrenBox:hover{
    background: var(--biz-hover-bg);
  }
  .active{
    background: var(--biz-selected-bg) !important;
    color: var(--biz-selected-text) !important ;
    font-weight: 600;
    .newLabel{
      background: #fff;
    }
  }
}
.hidePopperClass .attention-badge{
  display: inline-block;
  margin-left: 8px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: #D54941;
  color: #fff;
  font-weight: 600;
  font-size: 11px;
  line-height: 18px;
  text-align: center;
  font-style: normal;
  vertical-align: middle;
}
.hidePopperClass1{
  padding: 8px !important;
}

/* 收起态浮层挂在 body 上，但 html 仍是它的祖先，所以品牌模式的选中色照样能覆盖到。
   浮层本体是白底，这里只换选中项的高亮（品牌模式的 --sidebar-* 选中色）。 */
html[data-module="brand"] .hidePopperClass .active{
  background: var(--sidebar-active-bg) !important;
  color: var(--sidebar-active-text) !important;
}
html[data-module="brand"] .hidePopperClass .title:hover,
html[data-module="brand"] .hidePopperClass .childrenBox:hover{
  background: var(--sidebar-hover);
}

/* Collapsed module switcher popover */
.collapseModulePopper {
  padding: 8px !important;
  min-width: 0 !important;
  .popper__arrow {
    display: none !important;
  }
  .collapse-module-list {
    .collapse-module-option {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 8px 12px;
      border-radius: 6px;
      cursor: pointer;
      font-family: Inter, sans-serif;
      font-size: 14px;
      font-weight: 400;
      color: #374151;
      white-space: nowrap;
      svg {
        width: 18px;
        height: 18px;
        color: #6B7280;
      }
      span {
        flex: 1;
      }
      i {
        font-size: 14px;
        color: #1E3A5F;
        font-weight: 700;
      }
      &:hover {
        background: var(--sidebar-hover);
      }
      &.active {
        background: var(--sidebar-active-bg);
        color: var(--sidebar-active-text);
        font-weight: 600;
        svg {
          color: var(--sidebar-accent);
        }
      }
    }
  }
}

/* Sidebar expand/collapse transitions */
.rm-expand-enter-active {
  transition: opacity 0.2s ease 0.08s;
}
.rm-expand-enter {
  opacity: 0;
}
.rm-expand-leave-active {
  transition: opacity 0.1s ease;
}
.rm-expand-leave-to {
  opacity: 0;
}

.rm-collapse-enter-active {
  transition: opacity 0.15s ease;
}
.rm-collapse-enter {
  opacity: 0;
}
.rm-collapse-leave-active {
  transition: opacity 0.08s ease;
}
.rm-collapse-leave-to {
  opacity: 0;
}

/* Sections whose data arrives async (the "BRAND OVERVIEW" list, populated
   once BrandOverview2/index.vue's own report resolves and reports groupBrands
   back — see brandNav.js) otherwise go from absent to fully rendered in one
   frame, reading as a jarring pop-in rather than content simply loading. */
.rm-section-fade-enter-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.rm-section-fade-enter {
  opacity: 0;
  transform: translateY(-4px);
}
</style>
